import ArticlePage from '@layouts/story'

const ArchivePage = (props) => {
  return (
    <ArticlePage
      {...props}
      archive
    />
  )
}

export default ArchivePage
